/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { TagCheckbox } from '@tag/tag-components-react-v2';

type CodePreviewOptionsProps = {
  mobileFriendly: boolean;
  mobileView: boolean;
  codeVisible: boolean;
  backgroundVisible: boolean;
  onMobileViewChange: (newMobileView: boolean) => void;
  onCodeVisibleChange: (newCodeVisible: boolean) => void;
  onBackgroundVisibleChange: (newBackgroundVisible: boolean) => void;
};

export const CodePreviewOptions = (props: CodePreviewOptionsProps) => {
  const styles = makeStyles();
  return (
    <div css={styles.root}>
      {props.mobileFriendly && (
        <TagCheckbox
          label="Mobile View"
          checked={props.mobileView}
          onValueChange={e => props.onMobileViewChange(e.detail.value)}
          css={styles.firstCheckbox}
        />
      )}
      <TagCheckbox
        label="Code"
        checked={props.codeVisible}
        onValueChange={e => props.onCodeVisibleChange(e.detail.value)}
        css={styles.otherCheckbox}
      />
      <TagCheckbox
        label="Background"
        checked={props.backgroundVisible}
        onValueChange={e => props.onBackgroundVisibleChange(e.detail.value)}
        css={styles.otherCheckbox}
      />
    </div>
  );
};

const makeStyles = () => {
  return {
    root: css`
      display: flex;
      padding: 20px 0 0 0;
      align-items: center;
      justify-content: flex-end;
    `,
    firstCheckbox: css`
      flex: 1 1 auto;
    `,
    otherCheckbox: css`
      flex: 0 0 auto;
      margin-left: 16px;
    `,
  };
};
